export const isValidDate = (d) => {
    if (Object.prototype.toString.call(d) === "[object Date]"){
        return !isNaN(d);
    }
    return false;
}
export const parseDateToDateTimeStr = (date) => {
    return date.toLocaleString(
        undefined,
        {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }
    )
}
export const parseDateToDateStr = (date) => {
    return date.toLocaleString(
        undefined,
        {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }
    )
}
export const parseDateToTimeStr = (date) => {
    return date.toLocaleString(
        undefined,
        {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        }
    )
}